module.exports = "<div class=\"col-lg-12 np\">\n<div id=\"map\" style=\"height:750px;\"></div>\n</div>\n{{zoomLevel}}<!--\n<table class=\"table-striped table-hover custom-table\">\n  <tbody>\n    <tr *ngFor=\"let row of cities\">\n      <td class=\"td\">{{row.Name}}</td>\n\n    </tr>\n  </tbody>\n</table>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/map/map.component.html
// module id = ./src/app/component/map/map.component.html
// module chunks = main